import { createSelector } from 'reselect';

const selectCache = (state: any) => state.webhookCache;

export const selectNotificationHistory = createSelector(
  selectCache,
  (cache: any) => cache.notifications
);
